@if (isPending()) {
  <app-status-indicator
    [appearance]="appearance()"
    status="pending"
    meaning="waiting"
    [label]="pendingLabel()"
  />
} @else if (isAccepted()) {
  <app-status-indicator
    [appearance]="appearance()"
    status="active"
    meaning="complete"
    [label]="acceptedLabel()"
  />
} @else if (showEmptyPlaceholder()) {
  <span [class]="emptyClass()">{{ emptyPlaceholder() }}</span>
}
